
import { Base64 } from "js-base64"
import addres from "./address"
import delivery from "./delivery"
import delivery2 from "./delivery2"
import pickup from "./pickup"
import payment from "./payment"
import summar from "./summary"
import info from "./info"
import coupons from "./coupons"
// import payThreeds from "./pay-threeds"
import tipsDialog from "./tips-dialog"
import { cardList, pay, authorizePay } from "@/api/pay.js"
import { goCheckoutV2, goCheckout, orderSubmit } from "@/api/checkout.js"
import { showGlobalMessage, getDeliveryMethod } from "@/utils/utils"
import { trackAddPaymentInfo } from "@/utils/track"

function _getParamsStr(payUrl) {
  let str = ""
  if (payUrl && payUrl.includes("?")) {
    str = payUrl.split("?")[1]
  }
  return str
}

export default {
  components: {
    addres,
    delivery,
    payment,
    summar,
    info,
    coupons,
    // payThreeds,
    tipsDialog,
    pickup,
    delivery2
  },
  data() {
    return {
      ageAlert: "",
      dialogVisible: false,
      loading: false,
      addrData: {},
      shipTimeItemList: [],
      payItemInfoList: [],
      wareInfo: {},
      bill: {},
      submit: {},
      toastInfos: {},
      couponReponse: {},
      checkoutParams: {},
      submitParams: {}, // 下单相关参数
      signNum: "", // 卡号
      orderNo: "", // 订单号
      orderList: "",
      afterPayProOrderPrice: "", // 优惠后的金额
      promotionEnjoy: {},
      errorTipsText: "",
      deliveryValue: "homeDelivery",
      shipTimeInfo: null,
      curSelStore: {}, // 当前门店信息
      timeIsActive: false
    }
  },
  computed: {
    submitCanClick() {
      return !!(
        this.payItemInfoList.length &&
        this.signNum &&
        (this.deliveryValue === "homeDelivery"
          ? this.submitParams.shipmentTime && this.submitParams.shipmentDate
          : true)
      )
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.checkoutParams = JSON.parse(Base64.decode(this.$route.query.params))
    // this.deliveryValue = getDeliveryMethod()
    this.curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
    this.getCheckout()
  },
  methods: {
    handleDialogCancel() {
      this.dialogVisible = false
    },
    handleDialogConfirm() {
      this.dialogVisible = false
      this.handleSubmit()
    },
    getParamsFromAddr(val) {
      if (!val) return
      if (this.deliveryValue === "homeDelivery") {
        this.submitParams = {
          ...this.submitParams,
          addressId: val.id,
          addressDetail: encodeURIComponent(val.addressDetail),
          addressName: encodeURIComponent(val.addressName),
          areaName1: val.areaName1,
          areaName2: val.areaName2,
          areaName3: val.areaName3,
          latitude: val.latitude,
          longitude: val.longitude,
          consignee: encodeURIComponent(val.consignee),
          mobilPhone: val.mobilPhone,
          remarks: val.remarks || ""
        }
      } else {
        // this.submitParams = {
        //   ...this.submitParams,
        //   addressName: encodeURIComponent(this.curSelStore.address),
        //   latitude: this.curSelStore.lat,
        //   longitude: this.curSelStore.lng,
        //   consignee: encodeURIComponent(this.checkoutParams.userName) || "",
        //   mobilPhone: this.checkoutParams.phone || "",
        //   remarks: ""
        // }
      }
    },
    getParamsFromTime(timeList) {
      const item = timeList.find(v => v.selected)
      const shipmentDate = item ? item.date : null
      const _item = item ? item.timeList_.find(v => v.selected) : null
      const shipmentTime = _item ? _item.value : null
      this.submitParams = {
        ...this.submitParams,
        shipmentTime,
        shipmentDate
      }
    },
    getParamsFromBill(val) {
      this.submitParams = {
        ...this.submitParams,
        afterPromotionPrice: val.afterPromotionPrice,
        afterPayProOrderPrice: val.subtotalPrice
      }
    },
    getParamsFromCoupon(val) {
      const item = val.valid
      if (item) {
        const couponCodeList = item.filter(v => v.checked).map(_v => _v.couponCode)
        this.submitParams = {
          ...this.submitParams,
          couponCodeList
        }
      }
    },
    handleAddrChanged() {
      this.getCheckout()
    },
    handleAddrPickChanged(val) {
      this.submitParams = {
        ...this.submitParams,
        consignee: encodeURIComponent(val.name),
        mobilPhone: val.code + " " + val.num
      }
    },
    handleInsChanged(val) {
      this.submitParams.remarks = val
    },
    handleTimeChanged(val) {
      this.checkoutParams = {
        ...this.checkoutParams,
        ...val
      }
      this.getCheckout(true)
    },
    handleCouponOpend() {
      // this.getCheckout();
    },
    handleCouponChanged(val) {
      this.checkoutParams = {
        ...this.checkoutParams,
        ...val,
        needHangUp: false
      }
      this.getCheckout()
    },
    handlePayChanged(val) {
      this.signNum = val
      this.checkoutParams = {
        ...this.checkoutParams,
        chosenSignNum: val
      }
      this.getCheckout()
      // this.getCardList();
    },
    handleCardChanged(val) {
      this.signNum = val.payload
      if (val.status === "select") {
        this.checkoutParams = {
          ...this.checkoutParams,
          chosenSignNum: val.payload
        }
        this.getCheckout()
      }
    },
    // handlePaySuccess() {
    //   this.$navigation.push({
    //     path: "/payment_result",
    //     query: {
    //       orderNo: this.orderNo,
    //       orderList: this.orderList
    //     }
    //   })
    // },
    // handlePayFail() {
    //   this.$navigation.push({
    //     path: "/pending_payment",
    //     query: {
    //       orderNo: this.orderNo,
    //       orderList: this.orderList
    //     }
    //   })
    // },
    // handlePaymentClose() {
    //   if (this.orderNo) {
    //     this.handlePayFail()
    //   }
    // },
    async toOrder(params = {}) {
      // if (this.deliveryValue === "clickCollect") {
      //   params.pickUpStoreId = this.curSelStore.erpStoreId
      //   params.pickUpStoreSapId = this.curSelStore.sapId
      //   params.pickUpStoreName = this.curSelStore.name
      // }
      try {
        const { data: res } = await orderSubmit({
          param: JSON.stringify({
            ...this.submitParams,
            ...params,
            reqTradeOrderCheckedStoreVOs: this.checkoutParams.checkedStores,
            tradeMode: this.checkoutParams.tradeMode,
            storeId: this.checkoutParams.masterStoreId,
            tradeCouponVOs: this.checkoutParams.tradeCouponVOs
          })
        })
        this.afterPayProOrderPrice = res.afterPayProOrderPrice
        this.orderNo = res.orderId
        if (res.orderList && res.orderList.length) {
          this.orderList = res.orderList.map(v => v.orderId).join(",")
        }
        return true
      } catch (error) {
        // 下单失败
        if (error.code === "0065" || error.code === "0067" || error.code === "0069") {
          this.$messageBox
            .open({
              title: this.$t("checkout.note"),
              message: error.result,
              confirmText: this.$t("checkout.payAnyway"),
              cancelText: this.$t("checkout.backToCart"),
              showClose: false,
              disMaskClick: true,
              showConfirm: error.code !== "0065"
            })
            .then(async () => {
              const res = await this.toOrder({
                tipCode: error.code
              })
              if (res) {
                await this.toPay()
              }
            })
            .catch(res => {
              this.$navigation.replace({
                path: "/cart"
              })
            })
        } else {
          this.$message.error(error.result)
        }
      }
    },
    async authorizePay(tradeNo) {
      this.loading = true
      try {
        const { data: res } = await authorizePay({
          params: JSON.stringify({
            tradeNo,
            isSaveCardNo: 1
          })
        })
        if (res.paymentStatus == "20001") {
          localStorage.setItem("pay_redirect_url", location.href)
          location.href = location.origin + "/o2opay.html?" + _getParamsStr(res.payUrl)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async toPay(params) {
      try {
        const { data: payRes } = await pay({
          requestFromUrl: "checkout",
          returnUrl: "",
          orderNo: this.orderNo,
          signNum: this.signNum,
          showPayFee: this.afterPayProOrderPrice,
          payFeeInCashier: this.afterPayProOrderPrice,
          ...params
        })
        this.authorizePay(payRes.tradeNo)
      } catch (error) {
        // 支付促销变化
        if (error.code === "1053") {
          this.$messageBox
            .open({
              title: this.$t("checkout.note"),
              message: error.msg,
              confirmText: this.$t("checkout.payAnyway"),
              cancelText: this.$t("checkout.backToCart"),
              showClose: false,
              disMaskClick: true
            })
            .then(res => {
              this.toPay({
                payFeeInCashier: 0
              })
            })
            .catch(res => {
              this.$navigation.replace({
                path: "/cart"
              })
            })
        } else if (error.code === "1008") {
          showGlobalMessage({
            message: `${error.msg || error.result || error.sourceMsg || this.$t("pendingPayment.payFail")}[${
              error.code
            }]`,
            gap: 150,
            iconClass: "messageWarning"
          })
          setTimeout(() => {
            this.$navigation.push({
              path: "/order_details",
              query: {
                orderId: this.orderNo
              }
            })
          }, 1000)
        } else {
          showGlobalMessage({
            message: `${error.msg || error.result || error.sourceMsg || this.$t("pendingPayment.payFail")}[${
              error.code
            }]`,
            gap: 150,
            iconClass: "messageWarning"
          })
          setTimeout(() => {
            this.handlePayFail()
          }, 500)
        }
      }
    },
    handleSubmitWrapper() {
      if (this.orderNo) {
        this.handlePayFail()
        return
      }
      if (this.ageAlert) {
        this.dialogVisible = true
      } else {
        this.handleSubmit()
      }
    },
    async handleSubmit() {
      this.loading = true
      try {
        const res = await this.toOrder()
        if (res) {
          await this.toPay()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // async getCardList() {
    //   try {
    //     const res = await cardList({
    //       params: JSON.stringify({
    //         payWay: 800
    //       })
    //     })
    //     this.payItemInfoList = res;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    getPromotionEnjoy(promotionEnjoy) {
      const commData = JSON.parse(localStorage.getItem("commData"))
      let res = {}
      if (promotionEnjoy && commData && commData.comm) {
        const venderId = commData.comm.venderId
        res = promotionEnjoy.find(v => v.venderId === venderId) || {}
      }
      return res
    },
    async getCheckout(timeIsActive) {
      this.loading = true
      try {
        const { data: res } = await goCheckoutV2({
          param: JSON.stringify({
            // addressId: this.addressId,
            // needHangUp: false,
            ...this.checkoutParams
          })
        })
        if (res && res.addrList) {
          this.addrData = res.addrList.find(v => v.checked)
          this.shipTimeItemList = res?.shipTimeItemList
          // this.wareInfo = res.wareInfo
          this.wareInfo = res.wareInfoV2
          this.bill = res.bill
          this.submit = res.submit
          this.toastInfos = res.toastInfos
          this.couponReponse = {
            ...res.couponReponse,
            useInstructionsTitle: res.useInstructionsTitle,
            useManual: res.useManual,
            afterPromotionPrice: res.bill.afterPromotionPrice,
            consignId: this.checkoutParams.addressId
          }
          this.payItemInfoList = res.payItemInfoList.filter(v => v.signNum)
          this.getParamsFromAddr(this.addrData)
          if (timeIsActive) {
            this.timeIsActive = timeIsActive
            this.getParamsFromTime(res.shipTimeItemList)
          }
          this.getParamsFromBill(res.bill)
          this.getParamsFromCoupon(res.couponReponse)
          this.submitParams.wareTotalNum = res.wareInfoV2.totalCount
          this.promotionEnjoy = this.getPromotionEnjoy(res.promotionEnjoy)
          this.ageAlert = res.ageAlert
          this.showNoCardTips = !(this.payItemInfoList && this.payItemInfoList.length)
          this.shipTimeInfo = res.shipTimeInfo
          this.errorTipsText = this.getSummaryErrorTips(res)
          if (res.toast && res.toast.length) {
            res.toast.forEach(v => {
              showGlobalMessage({
                message: v,
                gap: 150,
                iconClass: "messageWarning"
              })
            })
          }
        }
      } catch (error) {
        this.$messageBox
          .open({
            title: this.$t("checkout.note"),
            message: error.result || error.message,
            confirmText: this.$t("checkout.backToCart"),
            showCancel: false,
            showClose: false,
            disMaskClick: true
          })
          .then(res => {
            this.$navigation.replace({
              path: "/cart"
            })
          })
          .catch(res => {})
      } finally {
        this.loading = false
      }
    },
    getSummaryErrorTips(res) {
      // 先看是否有选择配送时间
      // const shipTime1 = res.shipTimeItemList.find(v => v.selected)
      // const shipTime2 = shipTime1 && shipTime1.timeList_ ? shipTime1.timeList_.find(v => v.selected) : null
      if (!this.timeIsActive && this.deliveryValue === "homeDelivery") {
        return this.$t("checkout.noTimeTips")
      }
      // 再看是否有选择的卡
      const payItemList = res.payItemInfoList.filter(v => v.signNum)
      if (!(payItemList && payItemList.length)) {
        return this.$t("checkout.noCardTips")
      }
      return ""
    },
    trackAddPaymentInfo() {
      trackAddPaymentInfo(this.wareInfo.wares, this.submitParams.couponCodeList, this.bill.subtotalPrice)
    },
    getChatNeedWareList() {
      if (!(this.wareInfo && this.wareInfo.wares && this.wareInfo.wares.length)) {
        return []
      }
      return this.wareInfo.wares.map(v => ({
        id: v.sku,
        name: v.name,
        brand: "",
        category: "",
        variant: "",
        quantity: v.count,
        price: v.promotionPrice
      }))
    }
  }
}
